import { MapPanel } from '../components/MapPanel';
import { Hero } from '../components/Hero';
import { graphql } from 'gatsby';
import { Seo } from '../components/Seo';
import styled from '@emotion/styled';

const StyledServingLocations = styled.section`
    padding: 3em 1em 2em;

    h2 {
        font-family: 'Bebas Neue', cursive;
        font-size: 48px;
        letter-spacing: 9.12px;
        text-transform: uppercase;
        margin-bottom: 0.5em;
    }
    p {
        font-family: 'Roboto', sans-serif;
        font-size: 18px;
        margin-bottom: 1em;
    }
    ul {
        list-style: disc;
        padding-left: 1.5em;
        li {
            font-family: 'Roboto', sans-serif;
            font-size: 18px;
            line-height: 1.557;
            margin-bottom: 0.25em;
        }
    }
`;

interface Props {
    heroImage: {
        edges: {
            node: {
                childImageSharp: {
                    gatsbyImageData: string;
                };
            };
        }[];
    };
}

const ContactUs: Page<Props> = ({ data }) => {
    const heroImage = data.heroImage.edges[0].node.childImageSharp.gatsbyImageData;
    return (
        <main>
            <Seo
                title="Contact Us – vytalcenter"
                description="Contact Vytal Center in Tarzana California (818) 578-5125"
            />
            <Hero heroImage={heroImage} title="CONTACT US" />
            <StyledServingLocations className="container">
                <h2>Serving Locations</h2>
                <p>We serve these locations:</p>
                <ul>
                    <li>Tarzana</li>
                    <li>Downey</li>
                    <li>Glendale</li>
                    <li>Bakersfield</li>
                    <li>Corona</li>
                </ul>
            </StyledServingLocations>
            <MapPanel />
        </main>
    );
};

export const query = graphql`
    query {
        heroImage: allFile(filter: { relativePath: { eq: "hero/girl-on-phone.jpeg" } }) {
            edges {
                node {
                    id
                    childImageSharp {
                        gatsbyImageData(width: 2000, quality: 90, webpOptions: { quality: 90 })
                    }
                }
            }
        }
    }
`;

export default ContactUs;
